import React, { Component, Fragment } from 'react';
import HeaderWebBook from '../../components/HeaderWebBook/HeaderWebBook';
import './webbookdetails.css';

export default class WebBookDetails extends Component {

    render() {
        return (
            <Fragment>
                <HeaderWebBook/>
                <div class="webbookdetails">
                    <section class="webbookdetails__container  webbookdetails__buy">
                        <button className="webbookdetails__buy__item webbookdetails__green">
                            COMPRE O WEBLIVRO LEIA
                            AGORA POR APENAS R$ 9,90
                        </button>
                        <button className="webbookdetails__buy__item webbookdetails__orange">
                            COMPRE O IMPRESSO
                            POR R$ 35,00
                        </button>
                        <button className="webbookdetails__buy__item webbookdetails__blue">
                            COMPRE O E-BOOK
                            POR R$ 15,00
                    </button>
                    </section>
                    <section id="book" className="webbookdetails__container webbookdetails__book">
                        <img src="https://res.cloudinary.com/uxmob/image/upload/v1532046880/mwrm4o1dayuuibyd3cyo.png" alt="" />
                    </section>
                    <section id="apresentation" className="webbookdetails__container webbookdetails__thebook">
                        <h2 className="webbookdetails__thebook__title">O LIVRO</h2>
                        <h3 className="webbookdetails__thebook__subtitle">
                            Manual do conselheiro de política cultural -
                            Um guia prático para os Conselhos Municipais de Cultura
                        </h3>
                        <p className="webbookdetails__thebook__text">
                            O Conselheiro Nonato, todos os meses, nas sessões ordinárias e extraordinárias do Conselho Estadual de Cultura da Bahia viajava o equivalente a 1.100 km para participar das reuniões. Apesar da distância, do cansaço da viagem, do quase bate-e-volta, chegava sempre disposto para discutir as políticas públicas do Estado e de seu Território. Assim como ele, centenas de outros Conselheiros de todo o país tomam para si a missão de tornar o Brasil um país melhor para os fazedores de Arte e da Cultura.
                            A luta de Nonato não tem sido em vão. Em apenas uma década e meia, o Brasil conseguiu construir uma Política de Cultura bem estruturada e com vários desdobramentos estruturantes. A criação do SNC – Sistema Nacional de Cultura, instituído pela Emenda Constitucional nº 71/12, de 29 de novembro de 2012, que acrescentou o artigo 216-A à Constituição Federal; a Lei nº 12.343/10, de 2 de dezembro de 2010, que criou o PNC – Plano Nacional de Cultura, e a nova composição e funcionamento do CNPC – Conselho Nacional de Políticas Culturais, estabelecido pelo Decreto nº 5.520/05, de 24 de agosto de 2005, são algumas dessas ações, quiçá, as mais importantes desde a promulgação da Constituição Federal de 1988, no campo cultural.
                        </p>
                    </section>
                    <section id="author" className="webbookdetails__container webbookdetails__theauthor">
                        <div className="webbookdetails__theauthor__midia">
                            <figure className="webbookdetails__theauthor__media__photo">
                                <img
                                    className="webbookdetails__theauthor__media__photo__image"
                                    src="https://res.cloudinary.com/uxmob/image/upload/v1532047322/p7rmcpqmgrgngailgzoi.png" alt="" />
                            </figure>
                        </div>
                        <div className="webbookdetails__theauthor__infos">
                            <h2 className="webbookdetails__theauthor__infos__title">
                                O AUTOR
                            </h2>
                            <h3 className="webbookdetails__theauthor__infos__name">
                                Pawlo Cidade
                            </h3>
                            <p className="webbookdetails__theauthor__infos__bio">
                                Pawlo Cidade é pedagogo, pós-graduado em Educação Ambiental e especialista em Projetos Culturais pelo MinC e FGV; produtor, dramaturgo e diretor de Teatro; autor de diversos livros infantojuvenis, entre eles O Tesouro Perdido das Terras do Sem Fim, Mistério na Lama Negra e A Batalha dos Nadadores. É colunista do Diário de Ilhéus, membro da Academia de Letras de Ilhéus (cadeira 13), da Sociedade Brasileira de Autores Teatrais – SBAT, do Conselho Estadual de Cultura e do Colegiado Setorial de Teatro da Bahia.
                            </p>
                        </div>

                    </section>
                    <section id="weblivro" className="webbookdetails__weblivro">
                        <div className="webbookdetails__container">
                            <h2 className="webbookdetails__weblivro__title">
                                WEBLIVRO
                        </h2>
                            <h3 className="webbookdetails__weblivro__subtitle">
                                Democratizando o acesso ao conteúdo
                        </h3>
                            <p className="webbookdetails__weblivro__text">
                                O <strong>web</strong>Livro é a mais nova modalidade de publicação da A5 editora.
                                Ela facilita o acesso ao conteúdo de forma instantânea e por um preço mais acessível.
                                 O processo é muito simples; é só clica no botão <strong className="webbookdetails__green__color">COMPRAR</strong>  pagar por cartão de crédito ou boleto e pronto o conteúdo está liberado para leitura.
                        </p>
                            <p className="webbookdetails__weblivro__feedback">
                                Esperamos que goste da experiência e nos dê seu <strong className="webbookdetails__green__orange" >feedback.</strong>
                            </p>
                            <p className="webbookdetails__weblivro__publish">
                                Caso seja um escritor e queira publicar <strong className="webbookdetails__green__orange" >clique aqui.</strong>
                            </p>
                        </div>
                    </section>
                    <section id="messageautor" className="webbookdetails__container webbookdetails__messageautor">
                        <h2 className="webbookdetails__messageautor__form__title">
                            FALE COM O AUTOR
                        </h2>
                        <form className="webbookdetails__messageautor__form">
                            <div className="row">
                                <div style={{position:'static'}} className=" col-xl-6">
                                    <div className="form-group">
                                        <label className="webbookdetails__messageautor__form__label" htmlFor="name">NOME</label>
                                        <input
                                            id="name"
                                            type="text"
                                            className="form-control webbookdetails__messageautor__form__input"
                                        />
                                    </div>
                                </div>
                                <div style={{position:'static'}} className="col-xl-6">
                                    <div className="form-group">
                                        <label className="webbookdetails__messageautor__form__label" htmlFor="lastName">SOBRENOME</label>
                                        <input
                                            id="lastName"
                                            type="text"
                                            className="form-control webbookdetails__messageautor__form__input"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div style={{position:'static'}} className="col-xl-12">
                                    <div className="form-group">
                                        <label className="webbookdetails__messageautor__form__label" htmlFor="EMAIL">EMAIL</label>
                                        <input
                                            type="email"
                                            className="form-control webbookdetails__messageautor__form__input"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div style={{position:'static'}} className="col-xl-12">
                                    <div className="form-group">
                                        <label className="webbookdetails__messageautor__form__label" htmlFor="EMAIL">MENSAGEM</label>
                                        <textarea
                                            rows="7"
                                            className="form-control webbookdetails__messageautor__form__textarea"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="webbookdetails__messageautor__form__buttoncontainer">
                                <button className="webbookdetails__messageautor__form__buttoncontainer__button" type="submit">
                                    ENVIAR
                           </button>
                            </div>
                        </form>
                    </section>

                </div>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/WebBookDetails/index.js